<template>
  <div
    :class="{
      customer_news_card:
        this.newsType == 'PERCE_NEWS' || this.newsType == 'GREAT_TIP',
    }"
  >
    <div class="card_date">
      {{ article.createdAt }}
    </div>
    <div class="card" @click="newsDetail(article)">
      <div class="thumb">
        <div class="inner"><img :src="article.bgImgPath" alt="" /></div>
      </div>
      <div class="card_con">
        <div class="line_clamp">{{ article.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from '@common/store/modules/board';
import * as actions from '@common/store/modules/board/types';
import dt from '@common/lib/filters/date';
export default {
  props: {
    article: Object,
    newsType: String,
  },
  methods: {
    ...mapMutations([actions.SET_ARTICLE]),
    async newsDetail(article) {
      this.$router.push({
        name: 'news.detail',
        params: { id: article.id },
      });
    },
  },
};
</script>
